import classes from './AvailableMeals.module.css'
import Card from '../UI/Card';
import Mealitem from './MealItem/MealItem';
import { useEffect, useState } from 'react';


const AvailableMeals = () => {
  const [meals, setMeals] = useState([])
  const [ isLoading, setIsLoading] = useState(true)
  const [httpError, setHttpError] = useState(null)

  useEffect(() => {
    const fetchMeals = async () => {
      const response = await fetch(
        'https://meals-f51f9-default-rtdb.firebaseio.com/meals.json'
        );

        if(!response.ok){
          throw new Error('Something went wrong...')
        }

      const responseData = await response.json()
      const loadedMeals = [];

      for(const key in responseData){
        loadedMeals.push({
          id: key,
          name: responseData[key].name,
          description: responseData[key].description,
          price: responseData[key].price
        })
      }
      setMeals(loadedMeals)
      setIsLoading(false)
    }
    
    fetchMeals().catch(error =>{
      setIsLoading(false)
      setHttpError(error.message)
    })
  },[]);

    if (isLoading) {
      return <section className={classes.mealsloading}>
        <p>Loading....</p>
      </section>
    }
    if(httpError){
      return <section className={classes.mealserror}>
        <p>{httpError}</p>
      </section>
    }

    const mealsList = meals.map(meal => 
      <Mealitem 
        key={meal.id} 
        id={meal.id} 
        name={meal.name} 
        description={meal.description} 
        price={meal.price}
      />)
    return <section className={classes.meals}>
        <Card>{mealsList}</Card>
    </section>
}

export default AvailableMeals